import React from "react"
import Container from "../../Container"
import ServiceCard from "./ServiceCard"
import { motion } from "framer-motion"
import { cardVariants } from "../../../utils/animations"
import learning_icon from "../../../images/learning_icon.svg"
import curriculum_icon from "../../../images/curriculum_icon.svg"
import technologies_icon from "../../../images/technologies_icon.svg"
import instructors_icon from "../../../images/instructors_icon.svg"
import experience_icon from "../../../images/experience_icon.svg"

function WhyChooseCognetiks() {
  const menu = [
    {
      title: "Expert Instructors",
      image: instructors_icon,
      url: "/services/cloud",
      description:
        "Learn from seasoned professionals with real-world experience in cloud computing, DevOps, automation, and more.",
    },
    {
      title: "Tailored Curriculum",
      image: curriculum_icon,
      url: "/",
      description:
        "Our training programs are designed to cater to various skill levels, from beginners to advanced practitioners. We customize content to match your specific needs.",
    },
    {
      title: "Hands-On Experience",
      image: experience_icon,
      url: "/",
      description:
        "Gain practical insights through hands-on labs and projects. Our training goes beyond theory, ensuring you can apply your knowledge in real-world scenarios.",
    },
    {
      title: "Cutting-Edge Technologies",
      image: technologies_icon,
      url: "/",
      description:
        "Stay ahead of the curve by training on the latest technologies and industry best practices.",
    },
    {
      title: "Flexible Learning Options",
      image: learning_icon,
      url: "/",
      description:
        "We understand the demands of a busy schedule. Choose from on-site or virtual training sessions that fit your timetable.",
    },
  ]

  return (
    <Container>
      <div className=" flex flex-col items-center mb-[300px]">
        <div className=" flex flex-col justify-center items-center  ">
          <motion.p
            variants={cardVariants}
            initial="offscreen"
            whileInView="onscreen"
            viewport={{ once: true, amount: 0.3 }}
            className="text-[#4D4D4D]  text-center mb-[24px] w-full  ]"
          >
            Get to know the value of training with us
          </motion.p>
          <motion.p
            variants={cardVariants}
            initial="offscreen"
            whileInView="onscreen"
            viewport={{ once: true, amount: 0.3 }}
            className="text-[24px] md:text-[32px] font-[700] text-center mb-16"
          >
            Why Choose Cognetiks for Training?
          </motion.p>
        </div>
        <div className="w-full flex flex-wrap gap-4 justify-center ">
          {menu.map((service, index) => (
            <div
              key={service.title}
              className={`w-[90%] md:w-[45%] lg:w-[30%]  self-center flex-0`}
            >
              <ServiceCard link={false} service={service} />
            </div>
          ))}
        </div>
      </div>
    </Container>
  )
}

export default WhyChooseCognetiks
